// componente che contiene i principali metodi di autenticazione (login, logout, refresh del token jwt, lettura del jwt)

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UtilsService } from '../service/helper/utils.service';
import { ApiService } from './api.service';

// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
    username: string;
    telephone: string;
    email: string;
    bodyid: string;
    firstname: string;
    lastname: string;
    profile: string;
    token: string;
}

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public schedulesData;
    public interval;
    public user: User;
    public currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public token: string

    constructor(private http: HttpClient, private router: Router, public apiservice: ApiService,
        private utilsService: UtilsService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    loginCheckUrl = 'https://sosimperium.multiutilitydelgarda.eu:8001/signin';
    refreshTokenUrl = 'https://sosimperium.multiutilitydelgarda.eu:8001/refresh';
    signupUrl = 'https://sosimperium.multiutilitydelgarda.eu:8001/users';


    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        var me = this;
        const requestOptions = {
            headers: new HttpHeaders({
            }),
            withCredentials: true
        };

        return this.http.post<any>(this.loginCheckUrl, { username, password }, requestOptions)
            .pipe(map(user => {
                if (user && user.token) {
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.token = user.token
                    this.user = user
                    this.currentUserSubject.next(user);
                }
                return user;
            }));
    }
    refresh() {
        const requestOptions = {
            headers: new HttpHeaders({
            }),
            withCredentials: true
        };
        return this.http.get<any>(this.refreshTokenUrl, requestOptions)
            .pipe(map(token => {
                if (token) {
                    this.token = token
                }
                return token;
            }));
    }

    logout() {
        localStorage.removeItem('currentUser');
        clearInterval(this.interval)
        this.currentUserSubject.next(null);
        this.router.navigate(['']);
        this.utilsService.hideLoader();

    }

    getAccessToken() {
        return this.token
    }
}